// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-input ion-item {
  --min-height: 69px !important;
  align-items: center;
}

.save-button {
  width: 100px;
  height: 46px;
  font-weight: bold;
  line-height: 1.25rem;
  font-size: 0.937rem;
  letter-spacing: 0;
  color: #FFFFFF;
  text-transform: uppercase;
  opacity: 1;
}

.send-button {
  width: 262px;
  height: 46px;
  font-weight: bold;
  line-height: 1.25rem;
  font-size: 0.937rem;
  letter-spacing: 0;
  color: #FFFFFF;
  text-transform: uppercase;
  opacity: 1;
}

.close-icon {
  width: 2rem;
  position: absolute;
  right: 0.3125rem;
  top: 0.3125rem;
}

.common-input ion-item ion-input {
  font-weight: bold;
  line-height: 1.5rem;
  font-size: 1rem;
  color: #434345;
}

table {
  width: 100%;
}
table tbody tr {
  border: 1px solid #D5DADC;
  height: 63px;
}
table tbody tr td {
  font-size: 1rem;
  color: #434345;
  font-weight: 600;
  padding: 1.25rem;
  width: 50%;
}
table tbody tr td:nth-child(2) {
  font-weight: 400;
}
table tbody tr .statusTd {
  padding: 0.625rem;
}
table tbody tr:nth-child(odd) {
  background-color: #F0F3F4;
}

.status-btn,
.pending,
.completed,
.rejected {
  font-weight: 400;
  max-width: 140px;
  font-size: 0.8375rem;
  line-height: 1.125rem;
  border-radius: 4px;
  width: 100%;
  text-transform: capitalize;
}

.pending {
  background: rgba(109, 207, 246, 0.2);
  color: var(--ion-color-primary-blue);
}

.completed {
  background: rgba(172, 219, 97, 0.25);
  color: var(--ion-color-secondary-green);
}

.rejected {
  background: rgba(233, 75, 75, 0.1);
  color: var(--ion-orange-primary);
}

.shipping,
.partially-completed {
  background: rgba(255, 121, 23, 0.17);
  color: var(--ion-color-primary-orange);
}`, "",{"version":3,"sources":["webpack://./src/app/components/payoutHistoryDetails/payoutHistoryDetails.component.scss"],"names":[],"mappings":"AAAA;EACC,6BAAA;EACA,mBAAA;AACD;;AAEA;EACC,YAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,UAAA;AACD;;AAEA;EACC,YAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,UAAA;AACD;;AAEA;EACC,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACD;;AAEA;EACC,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AACD;;AAEA;EACC,WAAA;AACD;AAEE;EACC,yBAAA;EACA,YAAA;AAAH;AAEG;EACC,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AAAJ;AAGG;EACC,gBAAA;AADJ;AAIG;EACC,iBAAA;AAFJ;AAME;EACC,yBAAA;AAJH;;AAUA;;;;EAIC,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;AAPD;;AAUA;EACC,oCAAA;EACA,oCAAA;AAPD;;AAUA;EACC,oCAAA;EACA,uCAAA;AAPD;;AAUA;EACC,kCAAA;EACA,gCAAA;AAPD;;AAUA;;EAEC,oCAAA;EACA,sCAAA;AAPD","sourcesContent":[".common-input ion-item {\n\t--min-height: 69px !important;\n\talign-items: center;\n}\n\n.save-button {\n\twidth: 100px;\n\theight: 46px;\n\tfont-weight: bold;\n\tline-height: 1.25rem;\n\tfont-size: 0.937rem;\n\tletter-spacing: 0;\n\tcolor: #FFFFFF;\n\ttext-transform: uppercase;\n\topacity: 1;\n}\n\n.send-button {\n\twidth: 262px;\n\theight: 46px;\n\tfont-weight: bold;\n\tline-height: 1.25rem;\n\tfont-size: 0.937rem;\n\tletter-spacing: 0;\n\tcolor: #FFFFFF;\n\ttext-transform: uppercase;\n\topacity: 1;\n}\n\n.close-icon {\n\twidth: 2rem;\n\tposition: absolute;\n\tright: 0.3125rem;\n\ttop: 0.3125rem;\n}\n\n.common-input ion-item ion-input {\n\tfont-weight: bold;\n\tline-height: 1.5rem;\n\tfont-size: 1rem;\n\tcolor: #434345;\n}\n\ntable {\n\twidth: 100%;\n\n\ttbody {\n\t\ttr {\n\t\t\tborder: 1px solid #D5DADC;\n\t\t\theight: 63px;\n\n\t\t\ttd {\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tcolor: #434345;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tpadding: 1.25rem;\n\t\t\t\twidth: 50%;\n\t\t\t}\n\n\t\t\ttd:nth-child(2) {\n\t\t\t\tfont-weight: 400;\n\t\t\t}\n\n\t\t\t.statusTd {\n\t\t\t\tpadding: 0.625rem;\n\t\t\t}\n\t\t}\n\n\t\ttr:nth-child(odd) {\n\t\t\tbackground-color: #F0F3F4;\n\t\t}\n\t}\n}\n\n\n.status-btn,\n.pending,\n.completed,\n.rejected {\n\tfont-weight: 400;\n\tmax-width: 140px;\n\tfont-size: 0.8375rem;\n\tline-height: 1.125rem;\n\tborder-radius: 4px;\n\twidth: 100%;\n\ttext-transform: capitalize;\n}\n\n.pending {\n\tbackground: rgba(109, 207, 246, 0.2);\n\tcolor: var(--ion-color-primary-blue);\n}\n\n.completed {\n\tbackground: rgba(172, 219, 97, 0.25);\n\tcolor: var(--ion-color-secondary-green);\n}\n\n.rejected {\n\tbackground: rgba(233, 75, 75, 0.1);\n\tcolor: var(--ion-orange-primary);\n}\n\n.shipping,\n.partially-completed {\n\tbackground: rgba(255, 121, 23, 0.17);\n\tcolor: var(--ion-color-primary-orange);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
